import { render, staticRenderFns } from "./OrgSignup.vue?vue&type=template&id=6df47c91&"
import script from "./OrgSignup.vue?vue&type=script&lang=js&"
export * from "./OrgSignup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports